import { AgencyCampaignSection, agencyCampaignLabels } from '../../features/agency/model';
import { ShigoDashboardContext } from '../../features/auth/dashboardDestination';
import { ShigoNavigationItem, type ShigoNavigationGroup } from './shigo-navigation.types';

const campaignItems = {
  [AgencyCampaignSection.Brands]: ShigoNavigationItem.CampaignBrands,
  [AgencyCampaignSection.Supply]: ShigoNavigationItem.CampaignSupply,
  [AgencyCampaignSection.ChannelGroups]: ShigoNavigationItem.CampaignChannelGroups,
  [AgencyCampaignSection.Campaigns]: ShigoNavigationItem.CampaignCampaigns,
  [AgencyCampaignSection.LineItems]: ShigoNavigationItem.CampaignLineItems,
  [AgencyCampaignSection.Creatives]: ShigoNavigationItem.CampaignCreatives,
};

export const agencyNavigationGroups: readonly ShigoNavigationGroup[] = [
  {
    id: ShigoNavigationItem.Campaigns,
    labelKey: 'nav.campaigns',
    activePaths: ['/a/$agencyId/campaigns'],
    access: [{ contexts: [ShigoDashboardContext.Agency] }],
    entries: [
      AgencyCampaignSection.Brands,
      AgencyCampaignSection.Campaigns,
      AgencyCampaignSection.Creatives,
      AgencyCampaignSection.Supply,
      AgencyCampaignSection.ChannelGroups,
    ].map((section) => ({
      id: campaignItems[section],
      labelKey: agencyCampaignLabels[section],
      to: '/a/$agencyId/campaigns/$section',
      section,
      activePaths:
        section === AgencyCampaignSection.Campaigns
          ? ['/a/$agencyId/campaigns/campaigns', '/a/$agencyId/campaigns/line-items']
          : [`/a/$agencyId/campaigns/${section}`],
    })),
  },
  {
    id: ShigoNavigationItem.Reporting,
    labelKey: 'nav.reporting',
    activePaths: ['/a/$agencyId/reporting'],
    access: [{ contexts: [ShigoDashboardContext.Agency] }],
    entries: [
      {
        id: ShigoNavigationItem.ReportExplorer,
        labelKey: 'nav.reporting.reportExplorer',
        to: '/a/$agencyId/reporting/report-explorer',
        activePaths: ['/a/$agencyId/reporting/report-explorer'],
      },
      {
        id: ShigoNavigationItem.SavedReports,
        labelKey: 'nav.reporting.savedReports',
        to: '/a/$agencyId/reporting/saved-reports',
        activePaths: ['/a/$agencyId/reporting/saved-reports'],
      },
    ],
  },
];
